import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(private router: Router, private authenticationService: AuthenticationService,
    private permissionsService: NgxPermissionsService, private activeRoute: ActivatedRoute) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.isLoggedIn
      .pipe(
        take(1),
        map((isLoggedIn: boolean) => {
          if (isLoggedIn) {
            if (route.queryParams['returnUrl']) {
              const splitRoute: string[] = route.queryParams['returnUrl'].split('/');
              this.router.navigate([`/${splitRoute[1]}`]);
            }
            else {
              this.router.navigate(['/']);
            }

            return false;
          }
          return true;
        })
      );
  }
}
